import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { getAgencyView } from "../../../../store/agency/actions";

const AgencyBookingDetail = () => {
  const { id } = useParams();
  const agencyDetail = useSelector((s) => s.agency.agencyDataById);
  //   console.log(agencyDetail, "agencyDetails2");

  useEffect(() => {
    if (id) getAgencyView();
  }, [id]);

  return (
    <>
      <section className="bookingDetail py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Link to="javascript:history.back()" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>

            <Col lg="12" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue">
                Booking Details View:
              </h5>
              <div className="cardCstm border rounded px-3 py-2">
                <Row>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Customer Name:
                    </span>

                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>{booking.customerName}</div>
                        ))}
                    </p>
                  </Col>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Driver Name:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>{booking.driverName}</div>
                        ))}
                    </p>
                  </Col>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Booking Number:
                    </span>

                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>{booking.bookingNumber}</div>
                        ))}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Service Name:
                    </span>

                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>{booking.serviceName}</div>
                        ))}
                    </p>
                  </Col>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Service Type:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>{booking.serviceType}</div>
                        ))}
                    </p>
                  </Col>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Created At:
                    </span>

                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>
                            {/* {booking.bookingCreatedAt} */}
                            {moment(booking.bookingCreatedAt).format(
                              "MM-DD-YYYY , HH:mm A"
                            )}
                          </div>
                        ))}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col lg="4" className="my-2">
                    <span className="w-50 text-muted fw-sbold">
                      Total Amount:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {agencyDetail?.bookings
                        ?.filter((booking) => booking._id === id)
                        .map((booking) => (
                          <div key={booking._id}>${booking.totalAmount}</div>
                        ))}
                    </p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AgencyBookingDetail;
